import { Badge, Button, Collapse } from "reactstrap";
import {
    GroupLearningDashboardDto,
    LearningMode,
    LearningRequestStatus
} from "../types/GroupLearningLocation";
import { useState } from "react";

interface Props {
    dashboard: GroupLearningDashboardDto;
    onUpdated: () => void;
}

const LearningPreferenceView = ({
    dashboard,
    onUpdated
}: Props) => {

const [isOpen, setIsOpen] = useState(false);

const toggle = () => setIsOpen(!isOpen);



    const getStatusColor = (status?: LearningRequestStatus) => {

        switch (status) {

            case LearningRequestStatus.Pending:
                return "warning";

            case LearningRequestStatus.Contacted:
                return "info";

            case LearningRequestStatus.MeetingScheduled:
                return "primary";

            case LearningRequestStatus.BatchAssigned:
                return "success";

            case LearningRequestStatus.Completed:
                return "dark";

            default:
                return "secondary";
        }
    };

    return (

        <>

          <div className="mb-4">

    <div
        className="d-flex justify-content-between align-items-center border rounded p-3 cursor-pointer"
        onClick={toggle}
        style={{ cursor: "pointer" }}
    >
        <div>
            <strong>Mode:</strong>{" "}
            <span className="fw-semibold">
                {dashboard.learningMode === LearningMode.Online
                    ? "🌐 Online"
                    : "📍 In Person"}
            </span>
        </div>

        <i
            className={`fas fa-chevron-${isOpen ? "up" : "down"}`}
        />
    </div>

    <Collapse isOpen={isOpen}>
        <div className="pt-3">

            {dashboard.learningMode === LearningMode.InPerson && (
                <div className="row g-3 mb-3">
                    <div className="col-12 col-sm-6 col-lg-3">
                        <div className="border rounded p-2 h-100">
                            <small className="text-muted d-block">
                                Country
                            </small>
                            <strong>{dashboard.country || "-"}</strong>
                        </div>
                    </div>

                    <div className="col-12 col-sm-6 col-lg-3">
                        <div className="border rounded p-2 h-100">
                            <small className="text-muted d-block">
                                State
                            </small>
                            <strong>{dashboard.state || "-"}</strong>
                        </div>
                    </div>

                    <div className="col-12 col-sm-6 col-lg-3">
                        <div className="border rounded p-2 h-100">
                            <small className="text-muted d-block">
                                District
                            </small>
                            <strong>{dashboard.district || "-"}</strong>
                        </div>
                    </div>

                    {dashboard.area && (
                        <div className="col-12 col-sm-6 col-lg-3">
                            <div className="border rounded p-2 h-100">
                                <small className="text-muted d-block">
                                    Area
                                </small>
                                <strong>{dashboard.area}</strong>
                            </div>
                        </div>
                    )}
                </div>
            )}

            <div className="mb-3">
                <strong>Nearby Members:</strong>{" "}
                <span className="badge bg-primary fs-6">
                    {dashboard.memberCount}
                </span>
            </div>

            <div className="d-grid d-sm-flex gap-2">
                <Button
                    color="primary"
                    className="w-100 w-sm-auto"
                    onClick={onUpdated}
                >
                    Update Preference
                </Button>

                {/* {dashboard.coordinatorName && (
                    <Button
                        color="success"
                        className="w-100 w-sm-auto"
                    >
                        Contact {dashboard.coordinatorName}
                    </Button>
                )} */}
            </div>

        </div>
    </Collapse>

</div>

        </>

    );

};

export default LearningPreferenceView;